<template>
  <div class="archivesSensor">
    <div class="div-fixed">
      <div class="header">
        <h1 class="title">年次レポート / {{ year }} 年 / 水</h1>
      </div>
      <div class="button-area">
        <span class="btn-submit" @click="excelDownload">Excelダウンロード</span>
        <span class="btn-submit" @click="showWaterHistory">グラフ表示</span>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <table class="stripe">
          <tr>
            <th>
              <input
                type="checkbox"
                v-model="allChecked"
                @change="changeAll(allChecked)"
              />
            </th>
            <th class="text-no">#</th>
            <th>ほ場名</th>
            <th class="text-tagno">センサータグ番号</th>
            <th class="text-date">測定開始日</th>
            <th class="text-date">測定終了日</th>
          </tr>
          <tr v-for="(row, index) in paddyFields" :key="index">
            <td class="text-centered">
              <input type="checkbox" v-model="row.checked" />
            </td>
            <td class="text-centered">{{ index + 1 }}</td>
            <td>{{ row.name }}</td>
            <td class="text-centered">{{ row.tag_no }}</td>
            <td class="text-centered">{{ row.from_date }}</td>
            <td class="text-centered">{{ row.to_date }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import XLSX from "xlsx";
import Loader from "@/mixins/loader";

export default {
  components: {},

  mixins: [Loader],

  props: {
    year: {
      type: Number,
      default: () => {
        return new Date().getFullYear();
      },
    },
  },

  data() {
    return {
      paddyFields: [],
      allChecked: false,
    };
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      await this.createData();
    });
  },

  methods: {
    ...mapActions(["retrieveSensorDataHistories"]),
    ...mapGetters(["getSensorDataHistories"]),

    /** 年間データダウンロード */
    excelDownload() {
      const histories = this.getSensorDataHistories();
      // 期間抽出
      let fromdt = null;
      let todt = null;
      histories.forEach((el) => {
        let tmpFromdt = new Date(el.sensor_start_datetime);
        let tmpTodt = null;
        if (el.sensor_end_datetime) {
          tmpTodt = new Date(el.sensor_end_datetime);
        } else {
          tmpTodt = new Date();
        }
        if (fromdt) {
          if (fromdt.getTime() > tmpFromdt.getTime()) {
            fromdt = tmpFromdt;
          }
        } else {
          fromdt = tmpFromdt;
        }
        if (todt) {
          if (todt.getTime() < tmpTodt.getTime()) {
            todt = tmpTodt;
          }
        } else {
          todt = tmpTodt;
        }
      });

      // ヘッダ
      var ws_data = [["時間"]];
      const cmn_headers = ["水位", "水温", "温度", "湿度", "明るさ相関値"];

      const dlDatas = this.createDownloadDataSet(
        fromdt,
        todt,
        histories.length * cmn_headers.length + 1
      );

      for (let cnt = 0; cnt < histories.length; cnt++) {
        // ヘッダ
        let headerName = "-" + histories[cnt].tag_no;
        if (histories[cnt].name) {
          headerName += "-" + histories[cnt].name;
        }
        cmn_headers.forEach((hel) => {
          ws_data[0].push(hel + headerName);
        });
        // データ
        histories[cnt].sensor_datas.forEach((item) => {
          // データ部
          const rcvdt = new Date(item.received_time);
          const rowDatas =
            dlDatas[rcvdt.getFullYear()][rcvdt.getMonth() + 1][rcvdt.getDate()][
              rcvdt.getHours()
            ];
          rowDatas[cnt * 5 + 1] = item.water_level;
          rowDatas[cnt * 5 + 2] = item.water_temp;
          rowDatas[cnt * 5 + 3] = item.temperature;
          rowDatas[cnt * 5 + 4] = item.humidity;
          rowDatas[cnt * 5 + 5] = item.illuminance;
        });
      }

      this.setDownloadDataSet(fromdt, todt, ws_data, dlDatas);

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      var wb_out = XLSX.write(wb, { type: "binary" });

      let dt = new Date();
      var blob = new Blob([this.s2ab(wb_out)], {
        type: "application/octet-stream",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "RiceLog_" +
        this.year +
        "_sensor_" +
        this.getStringFromDate(dt, "YYYYMMDDhhmmss") +
        ".xlsx";
      link.click();
    },

    createDownloadDataSet(fromdt, todt, len) {
      const dldatas = {};
      // ラベルの作成とチャートデータ構造作成

      for (
        let tmpdt = new Date(
            fromdt.getFullYear(),
            fromdt.getMonth(),
            fromdt.getDate(),
            0,
            0,
            0
          ),
          enddt = new Date(
            todt.getFullYear(),
            todt.getMonth(),
            todt.getDate(),
            23,
            59,
            59
          );
        tmpdt.getTime() <= enddt.getTime();
        tmpdt.setDate(tmpdt.getDate() + 1)
      ) {
        const dtYear = tmpdt.getFullYear();
        const dtMonth = tmpdt.getMonth() + 1;
        const dtDay = tmpdt.getDate();

        // ラベルの作成とチャートデータ構造作成
        if (!dldatas[dtYear]) {
          dldatas[dtYear] = {};
        }
        if (!dldatas[dtYear][dtMonth]) {
          dldatas[dtYear][dtMonth] = {};
        }
        if (!dldatas[dtYear][dtMonth][dtDay]) {
          dldatas[dtYear][dtMonth][dtDay] = {};
        }
        for (let hour = 0; hour < 24; hour++) {
          dldatas[dtYear][dtMonth][dtDay][hour] = [len];
          // １列目は日時
          dldatas[dtYear][dtMonth][dtDay][hour][0] = this.getStringFromDate(
            new Date(dtYear, dtMonth - 1, dtDay, hour, 0, 0, 0),
            "YYYY/MM/DD hh:mm"
          );
        }
      }
      return dldatas;
    },
    setDownloadDataSet(fromdt, todt, datas, dataSets) {
      for (
        let tmpdt = new Date(
            fromdt.getFullYear(),
            fromdt.getMonth(),
            fromdt.getDate(),
            0,
            0,
            0
          ),
          enddt = new Date(
            todt.getFullYear(),
            todt.getMonth(),
            todt.getDate(),
            23,
            59,
            59
          );
        tmpdt.getTime() <= enddt.getTime();
        tmpdt.setDate(tmpdt.getDate() + 1)
      ) {
        const dtYear = tmpdt.getFullYear();
        const dtMonth = tmpdt.getMonth() + 1;
        const dtDay = tmpdt.getDate();

        for (let hour = 0; hour < 24; hour++) {
          datas.push(dataSets[dtYear][dtMonth][dtDay][hour]);
        }
      }
    },

    /** 変換して返す */
    getStringFromDate(date, format) {
      var year_str = date.getFullYear();
      var month_str = date.getMonth() + 1;
      var day_str = date.getDate();
      var hour_str = date.getHours();
      var minute_str = date.getMinutes();
      var second_str = date.getSeconds();

      month_str = ("0" + month_str).slice(-2);
      day_str = ("0" + day_str).slice(-2);
      hour_str = ("0" + hour_str).slice(-2);
      minute_str = ("0" + minute_str).slice(-2);
      second_str = ("0" + second_str).slice(-2);

      var format_str = format;
      format_str = format_str.replace("YYYY", year_str);
      format_str = format_str.replace("MM", month_str);
      format_str = format_str.replace("DD", day_str);
      format_str = format_str.replace("hh", hour_str);
      format_str = format_str.replace("mm", minute_str);
      format_str = format_str.replace("ss", second_str);

      return format_str;
    },

    // stringをArrayBufferに変換する
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },

    /** 1年間分のデータを作成 */
    async createData() {
      await this.retrieveSensorDataHistories();
      const list = this.getSensorDataHistories();
      list.forEach((el) => {
        let tmpDt = el.sensor_end_datetime;
        if (tmpDt) {
          tmpDt = this.formatDate(new Date(tmpDt), "YYYY-MM-DD");
        }
        this.paddyFields.push({
          paddy_field_id: el.paddy_field_id,
          name: el.name,
          tag_no: el.tag_no,
          from_date: this.formatDate(
            new Date(el.sensor_start_datetime),
            "YYYY-MM-DD"
          ),
          to_date: tmpDt,
          checked: false,
        });
      });
    },

    formatDate(src, format) {
      const date = new Date(src);

      var year_str = date.getFullYear();
      var month_str = date.getMonth() + 1;
      var day_str = date.getDate();
      var hour_str = date.getHours();
      var minute_str = date.getMinutes();
      var second_str = date.getSeconds();

      month_str = ("0" + month_str).slice(-2);
      day_str = ("0" + day_str).slice(-2);
      hour_str = ("0" + hour_str).slice(-2);
      minute_str = ("0" + minute_str).slice(-2);
      second_str = ("0" + second_str).slice(-2);

      var format_str = format;
      format_str = format_str.replace("YYYY", year_str);
      format_str = format_str.replace("MM", month_str);
      format_str = format_str.replace("DD", day_str);
      format_str = format_str.replace("hh", hour_str);
      format_str = format_str.replace("mm", minute_str);
      format_str = format_str.replace("ss", second_str);

      return format_str;
    },

    changeAll(val) {
      this.paddyFields.forEach((el) => {
        el.checked = val;
      });
    },

    showWaterHistory() {
      let checkedList = [];
      this.paddyFields.forEach((el, idx) => {
        if (el.checked) {
          checkedList.push(idx);
        }
      });

      this.$router.push({
        name: "archives-sensor",
        params: {
          year: this.year,
          historyIdxList: checkedList,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.archivesSensor {
  .div-fixed {
    z-index: 1;
    // position: fixed;
    width: calc(100vw - 266px);
    background-color: #f0f3f5;
    border-bottom: 1px solid #bbb;
  }
  .header {
    margin: 2rem 2rem 1rem 2rem;
  }
  .button-area {
    width: auto;
    height: calc(100% - 130px);
    position: relative;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-bottom: 10px;

    .btn-submit {
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }
  }
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;
    }
  }
  table {
    //    margin: 30px auto 30px;
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;

    &.text-no {
      min-width: 50px;
    }
    &.text-date {
      min-width: 100px;
    }
    &.text-tagno {
      min-width: 80px;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;

    &.text-centered {
      text-align: center;
    }
    &.text-right {
      text-align: right;
    }
    &.text-left {
      text-align: left;
    }
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }

  #input input[type="checkbox"] {
    display: none;
  }
  #input input[type="checkbox"] + label:before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center left;
    width: 25px;
    height: 20px;
    background-size: contain;
    vertical-align: middle;
    display: inline-block;
  }
  #input input[type="checkbox"]:checked + label:before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center left;
    width: 25px;
    height: 20px;
    background-size: contain;
    vertical-align: middle;
    display: inline-block;
  }
}
</style>
